import React, { useState, useEffect, useCallback, useRef } from 'react';
import api from '../../services/api';
import './Dashboard.css';

// SVG Icons
const Icons = {
  inventory: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
      <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
      <line x1="12" y1="22.08" x2="12" y2="12" />
    </svg>
  ),
  products: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20.38 3.46L16 2a4 4 0 0 1-8 0L3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.47a1 1 0 0 0 .99.84H6v10c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V10h2.15a1 1 0 0 0 .99-.84l.58-3.47a2 2 0 0 0-1.34-2.23z" />
    </svg>
  ),
  settings: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="3" />
      <path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42" />
    </svg>
  ),
  vendor: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
      <polyline points="9 22 9 12 15 12 15 22" />
    </svg>
  ),
  color: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="13.5" cy="6.5" r="2.5" />
      <circle cx="19" cy="13" r="2.5" />
      <circle cx="16" cy="20" r="2.5" />
      <circle cx="8" cy="20" r="2.5" />
      <circle cx="5" cy="13" r="2.5" />
      <circle cx="12" cy="13" r="4" />
    </svg>
  ),
  blank: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
      <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
    </svg>
  ),
  design: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20" />
      <path d="M2 12h20" />
    </svg>
  ),
  chevronRight: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="9 18 15 12 9 6" />
    </svg>
  ),
  chevronDown: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="6 9 12 15 18 9" />
    </svg>
  ),
  lowStock: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
      <line x1="12" y1="9" x2="12" y2="13" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  ),
  filter: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
    </svg>
  ),
  sort: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="4" y1="6" x2="16" y2="6" />
      <line x1="4" y1="12" x2="12" y2="12" />
      <line x1="4" y1="18" x2="8" y2="18" />
      <polyline points="15 15 18 18 21 15" />
      <line x1="18" y1="9" x2="18" y2="18" />
    </svg>
  ),
  check: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="20 6 9 17 4 12" />
    </svg>
  ),
  x: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  ),
  download: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <polyline points="7 10 12 15 17 10" />
      <line x1="12" y1="15" x2="12" y2="3" />
    </svg>
  ),
  plus: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <line x1="12" y1="5" x2="12" y2="19" />
      <line x1="5" y1="12" x2="19" y2="12" />
    </svg>
  ),
  minus: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <line x1="5" y1="12" x2="19" y2="12" />
    </svg>
  ),
  box: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
    </svg>
  ),
  dollar: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="12" y1="1" x2="12" y2="23" />
      <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
    </svg>
  ),
  tag: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
      <line x1="7" y1="7" x2="7.01" y2="7" />
    </svg>
  ),
  settings2: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
    </svg>
  )
};

const formatCurrency = (value) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(value || 0);
};

// Toast notification system
const ToastContext = React.createContext();

function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((message, type = 'info') => {
    const id = Date.now();
    setToasts(prev => [...prev, { id, message, type }]);
    setTimeout(() => {
      setToasts(prev => prev.filter(t => t.id !== id));
    }, 4000);
  }, []);

  const removeToast = (id) => {
    setToasts(prev => prev.filter(t => t.id !== id));
  };

  return (
    <ToastContext.Provider value={{ addToast }}>
      {children}
      <div className="toast-container">
        {toasts.map(toast => (
          <div key={toast.id} className={`toast toast-${toast.type}`}>
            <span className="toast-icon">
              {toast.type === 'success' ? Icons.check : toast.type === 'error' ? Icons.x : Icons.lowStock}
            </span>
            <span className="toast-message">{toast.message}</span>
            <button className="toast-close" onClick={() => removeToast(toast.id)}>
              {Icons.x}
            </button>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

const useToast = () => React.useContext(ToastContext);

function SpiritWearDashboard() {
  const [activeSection, setActiveSection] = useState('inventory');
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Data states
  const [inventory, setInventory] = useState([]);
  const [products, setProducts] = useState([]);
  const [blanks, setBlanks] = useState([]);
  const [colors, setColors] = useState([]);
  const [designs, setDesigns] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [sizes, setSizes] = useState([]);

  // Search/filter
  const [searchTerm, setSearchTerm] = useState('');

  // Settings
  const [lowStockThreshold, setLowStockThreshold] = useState(() => {
    const saved = localStorage.getItem('spiritWear_lowStockThreshold');
    return saved ? parseInt(saved, 10) : 3;
  });
  const [showSettings, setShowSettings] = useState(false);

  const updateLowStockThreshold = (value) => {
    const num = parseInt(value, 10) || 3;
    setLowStockThreshold(num);
    localStorage.setItem('spiritWear_lowStockThreshold', num.toString());
  };

  const fetchAll = useCallback(async () => {
    try {
      const [summaryRes, vendorsRes, colorsRes, sizesRes, blanksRes, designsRes, productsRes, inventoryRes] = await Promise.all([
        api.get('/spirit-wear/summary'),
        api.get('/spirit-wear/vendors'),
        api.get('/spirit-wear/colors'),
        api.get('/spirit-wear/sizes'),
        api.get('/spirit-wear/blanks'),
        api.get('/spirit-wear/designs'),
        api.get('/spirit-wear/products'),
        api.get('/spirit-wear/inventory')
      ]);
      setSummary(summaryRes.data);
      setVendors(vendorsRes.data);
      setColors(colorsRes.data);
      setSizes(sizesRes.data);
      setBlanks(blanksRes.data);
      setDesigns(designsRes.data);
      setProducts(productsRes.data);
      setInventory(inventoryRes.data);
    } catch (err) {
      setError('Failed to load data');
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchAll();
  }, [fetchAll]);

  const refreshData = () => fetchAll();

  if (loading) {
    return <div className="sw-loading">Loading Spirit Wear...</div>;
  }

  const navItems = [
    { id: 'inventory', label: 'Inventory', icon: Icons.inventory, count: summary?.total_skus || 0 },
    { id: 'products', label: 'Products', icon: Icons.products, count: products.length },
    { id: 'setup', label: 'Setup', icon: Icons.settings }
  ];

  return (
    <div className="sw-container">
      <aside className="sw-sidebar">
        <div className="sw-sidebar-header">
          <div className="sw-brand">
            <div className="sw-brand-icon">{Icons.products}</div>
            <div className="sw-brand-text">
              <h2>Spirit Wear</h2>
              <span>Inventory System</span>
            </div>
          </div>
          {summary && (
            <div className="sw-sidebar-stats">
              <div className="sw-stat-card">
                <div className="stat-value">{(summary.total_units || 0).toLocaleString()}</div>
                <div className="stat-label">Units</div>
              </div>
              <div className="sw-stat-card">
                <div className="stat-value">{formatCurrency(summary.total_retail_value)}</div>
                <div className="stat-label">Value</div>
              </div>
              {(summary.low_stock_skus > 0 || summary.low_stock_count > 0) && (
                <div className="sw-stat-card full-width warning">
                  <div className="stat-icon">{Icons.lowStock}</div>
                  <div className="stat-content">
                    <span className="stat-value">{summary.low_stock_skus || summary.low_stock_count}</span>
                    <span className="stat-label">items low on stock</span>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>

        <nav className="sw-nav">
          <div className="sw-nav-label">Navigation</div>
          {navItems.map(item => (
            <button
              key={item.id}
              className={`sw-nav-item ${activeSection === item.id ? 'active' : ''}`}
              onClick={() => setActiveSection(item.id)}
            >
              <span className="nav-icon">{item.icon}</span>
              <span className="nav-label">{item.label}</span>
              {item.count !== undefined && (
                <span className="nav-count">{item.count}</span>
              )}
            </button>
          ))}
        </nav>

        <div className="sw-sidebar-footer">
          <div className="sw-nav-label">Preferences</div>
          <button className={`settings-toggle ${showSettings ? 'active' : ''}`} onClick={() => setShowSettings(!showSettings)}>
            <span className="settings-icon">{Icons.settings2}</span>
            <span>Settings</span>
            <span className="settings-chevron">{showSettings ? Icons.chevronDown : Icons.chevronRight}</span>
          </button>
          {showSettings && (
            <div className="settings-panel">
              <div className="settings-row">
                <label>Low Stock Threshold</label>
                <input
                  type="number"
                  min="1"
                  max="100"
                  value={lowStockThreshold}
                  onChange={(e) => updateLowStockThreshold(e.target.value)}
                />
              </div>
              <p className="settings-hint">Items with ≤ {lowStockThreshold} units are marked as low stock</p>
            </div>
          )}
        </div>
      </aside>

      <main className="sw-main">
        {error && <div className="sw-error">{error}</div>}

        {activeSection === 'inventory' && (
          <InventorySection
            inventory={inventory}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            onRefresh={refreshData}
            sizes={sizes}
            vendors={vendors}
            colors={colors}
            designs={designs}
            lowStockThreshold={lowStockThreshold}
          />
        )}

        {activeSection === 'products' && (
          <ProductsSection
            products={products}
            blanks={blanks}
            colors={colors}
            designs={designs}
            onRefresh={refreshData}
          />
        )}

        {activeSection === 'setup' && (
          <SetupWizard
            vendors={vendors}
            colors={colors}
            blanks={blanks}
            designs={designs}
            onRefresh={refreshData}
          />
        )}
      </main>
    </div>
  );
}

// ============ INVENTORY SECTION ============
function InventorySection({ inventory, searchTerm, setSearchTerm, onRefresh, sizes, vendors, colors, designs, lowStockThreshold = 3 }) {
  const [isEditing, setIsEditing] = useState(false);
  const [editData, setEditData] = useState({});
  const [saving, setSaving] = useState(false);
  const [expandedProduct, setExpandedProduct] = useState(null);
  const [filters, setFilters] = useState({ vendor: '', color: '', design: '', lowStock: false });
  const [sortBy, setSortBy] = useState('sku');
  const [showFilters, setShowFilters] = useState(false);
  const toast = useToast();

  // Get unique size codes in sort order
  const sizeColumns = sizes || [];

  // Group inventory by product
  const groupedInventory = inventory.reduce((acc, item) => {
    const key = item.product_id;
    if (!acc[key]) {
      acc[key] = {
        product_id: item.product_id,
        sku_prefix: item.sku_prefix,
        vendor_name: item.vendor_name,
        vendor_id: item.vendor_id,
        blank_name: item.blank_name,
        color_name: item.color_name,
        color_id: item.color_id,
        hex_color: item.hex_color,
        design_name: item.design_name,
        design_id: item.design_id,
        design_image: item.design_image,
        sizes: {},
        total: 0,
        totalValue: 0
      };
    }
    acc[key].sizes[item.size_code] = {
      inventory_id: item.inventory_id,
      quantity: item.quantity,
      cost: item.cost || 0,
      price: item.price || 0,
      is_enabled: item.is_enabled !== false
    };
    if (item.is_enabled !== false) {
      acc[key].total += item.quantity;
      acc[key].totalValue += item.quantity * (item.price || 0);
    }
    return acc;
  }, {});

  // Apply filters
  let filteredProducts = Object.values(groupedInventory).filter(p => {
    if (searchTerm && !p.sku_prefix.toLowerCase().includes(searchTerm.toLowerCase()) &&
        !p.design_name.toLowerCase().includes(searchTerm.toLowerCase()) &&
        !p.vendor_name.toLowerCase().includes(searchTerm.toLowerCase())) {
      return false;
    }
    if (filters.vendor && p.vendor_name !== filters.vendor) return false;
    if (filters.color && p.color_name !== filters.color) return false;
    if (filters.design && p.design_name !== filters.design) return false;
    if (filters.lowStock && p.total > lowStockThreshold) return false;
    return true;
  });

  // Apply sorting
  filteredProducts = [...filteredProducts].sort((a, b) => {
    switch (sortBy) {
      case 'sku': return a.sku_prefix.localeCompare(b.sku_prefix);
      case 'qty-asc': return a.total - b.total;
      case 'qty-desc': return b.total - a.total;
      case 'value-desc': return b.totalValue - a.totalValue;
      case 'vendor': return a.vendor_name.localeCompare(b.vendor_name);
      default: return 0;
    }
  });

  const activeFilterCount = [filters.vendor, filters.color, filters.design, filters.lowStock].filter(Boolean).length;

  const clearFilters = () => {
    setFilters({ vendor: '', color: '', design: '', lowStock: false });
  };

  // Get unique values for filter dropdowns
  const uniqueVendors = [...new Set(Object.values(groupedInventory).map(p => p.vendor_name))].sort();
  const uniqueColors = [...new Set(Object.values(groupedInventory).map(p => p.color_name))].sort();
  const uniqueDesigns = [...new Set(Object.values(groupedInventory).map(p => p.design_name))].sort();

  // Calculate summary stats for filtered products
  const summaryStats = {
    totalProducts: filteredProducts.length,
    totalUnits: filteredProducts.reduce((sum, p) => sum + p.total, 0),
    totalValue: filteredProducts.reduce((sum, p) => sum + p.totalValue, 0),
    lowStockCount: filteredProducts.filter(p => p.total <= lowStockThreshold).length
  };

  // Export to CSV
  const exportToCSV = () => {
    const headers = ['SKU', 'Vendor', 'Blank', 'Color', 'Design', ...sizeColumns.map(s => s.code), 'Total', 'Value'];
    const rows = filteredProducts.map(p => {
      const sizeQtys = sizeColumns.map(s => {
        const info = p.sizes[s.code];
        return info?.is_enabled ? info.quantity : '';
      });
      return [
        p.sku_prefix,
        p.vendor_name,
        p.blank_name,
        p.color_name,
        p.design_name,
        ...sizeQtys,
        p.total,
        p.totalValue.toFixed(2)
      ];
    });

    const csvContent = [
      headers.join(','),
      ...rows.map(row => row.map(cell => `"${cell}"`).join(','))
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `spirit-wear-inventory-${new Date().toISOString().split('T')[0]}.csv`;
    a.click();
    URL.revokeObjectURL(url);
    toast.addToast('Inventory exported to CSV', 'success');
  };

  const startEditing = () => {
    // Initialize edit data from current inventory
    const data = {};
    filteredProducts.forEach(product => {
      Object.entries(product.sizes).forEach(([sizeCode, sizeInfo]) => {
        data[sizeInfo.inventory_id] = { quantity: sizeInfo.quantity };
      });
    });
    setEditData(data);
    setIsEditing(true);
  };

  const cancelEditing = () => {
    setIsEditing(false);
    setEditData({});
  };

  const updateQuantity = (inventoryId, value) => {
    setEditData(prev => ({
      ...prev,
      [inventoryId]: { quantity: value }
    }));
  };

  const saveAllChanges = async () => {
    setSaving(true);
    try {
      // Group changes by product
      const changesByProduct = {};
      Object.entries(editData).forEach(([inventoryId, data]) => {
        // Find which product this belongs to
        for (const product of filteredProducts) {
          for (const [sizeCode, sizeInfo] of Object.entries(product.sizes)) {
            if (sizeInfo.inventory_id === parseInt(inventoryId)) {
              const newQty = parseInt(data.quantity, 10) || 0;
              if (newQty !== sizeInfo.quantity) {
                if (!changesByProduct[product.product_id]) {
                  changesByProduct[product.product_id] = [];
                }
                changesByProduct[product.product_id].push({
                  inventoryId: parseInt(inventoryId),
                  quantity: newQty
                });
              }
              break;
            }
          }
        }
      });

      // Send updates for each product that has changes
      for (const [productId, adjustments] of Object.entries(changesByProduct)) {
        if (adjustments.length > 0) {
          await api.put(`/spirit-wear/products/${productId}/inventory`, {
            adjustments,
            reason: 'bulk_adjustment'
          });
        }
      }

      onRefresh();
      cancelEditing();
      toast.addToast('Inventory updated successfully', 'success');
    } catch (err) {
      toast.addToast(err.response?.data?.error || 'Failed to save', 'error');
    } finally {
      setSaving(false);
    }
  };

  const toggleExpanded = (productId) => {
    setExpandedProduct(expandedProduct === productId ? null : productId);
  };

  // Quick adjust - increment/decrement a single size
  const quickAdjust = async (productId, inventoryId, currentQty, delta) => {
    const newQty = Math.max(0, currentQty + delta);
    if (newQty === currentQty) return;

    try {
      await api.put(`/spirit-wear/products/${productId}/inventory`, {
        adjustments: [{ inventoryId, quantity: newQty }],
        reason: delta > 0 ? 'quick_add' : 'quick_remove'
      });
      onRefresh();
    } catch (err) {
      toast.addToast(err.response?.data?.error || 'Failed to adjust', 'error');
    }
  };

  return (
    <div className="sw-section inventory-grid-section">
      {/* Summary Cards */}
      <div className="inventory-summary-cards">
        <div className="summary-card">
          <span className="summary-icon">{Icons.tag}</span>
          <div className="summary-content">
            <span className="summary-value">{summaryStats.totalProducts}</span>
            <span className="summary-label">Products</span>
          </div>
        </div>
        <div className="summary-card">
          <span className="summary-icon">{Icons.box}</span>
          <div className="summary-content">
            <span className="summary-value">{summaryStats.totalUnits.toLocaleString()}</span>
            <span className="summary-label">Total Units</span>
          </div>
        </div>
        <div className="summary-card">
          <span className="summary-icon">{Icons.dollar}</span>
          <div className="summary-content">
            <span className="summary-value">{formatCurrency(summaryStats.totalValue)}</span>
            <span className="summary-label">Retail Value</span>
          </div>
        </div>
        <div className={`summary-card ${summaryStats.lowStockCount > 0 ? 'warning' : ''}`}>
          <span className="summary-icon">{Icons.lowStock}</span>
          <div className="summary-content">
            <span className="summary-value">{summaryStats.lowStockCount}</span>
            <span className="summary-label">Low Stock</span>
          </div>
        </div>
      </div>

      <header className="sw-section-header">
        <h1>Inventory</h1>
        <div className="header-controls">
          <div className="sw-search">
            <input
              type="text"
              placeholder="Search by SKU, design, vendor..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <button
            className={`btn-icon ${showFilters || activeFilterCount > 0 ? 'active' : ''}`}
            onClick={() => setShowFilters(!showFilters)}
            title="Filters"
          >
            {Icons.filter}
            {activeFilterCount > 0 && <span className="filter-badge">{activeFilterCount}</span>}
          </button>
          <div className="sort-dropdown">
            <span className="sort-icon">{Icons.sort}</span>
            <select value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
              <option value="sku">SKU</option>
              <option value="qty-desc">Qty: High to Low</option>
              <option value="qty-asc">Qty: Low to High</option>
              <option value="value-desc">Value: High to Low</option>
              <option value="vendor">Vendor</option>
            </select>
          </div>
          <button
            className="btn-icon"
            onClick={exportToCSV}
            title="Export to CSV"
          >
            {Icons.download}
          </button>
          {isEditing ? (
            <div className="edit-buttons">
              <button className="btn-cancel" onClick={cancelEditing} disabled={saving}>Cancel</button>
              <button className="btn-save" onClick={saveAllChanges} disabled={saving}>
                {saving ? 'Saving...' : 'Save All'}
              </button>
            </div>
          ) : (
            <button className="btn-primary" onClick={startEditing}>Edit Quantities</button>
          )}
        </div>
      </header>

      {showFilters && (
        <div className="filter-bar">
          <select
            value={filters.vendor}
            onChange={(e) => setFilters(f => ({ ...f, vendor: e.target.value }))}
          >
            <option value="">All Vendors</option>
            {uniqueVendors.map(v => <option key={v} value={v}>{v}</option>)}
          </select>
          <select
            value={filters.color}
            onChange={(e) => setFilters(f => ({ ...f, color: e.target.value }))}
          >
            <option value="">All Colors</option>
            {uniqueColors.map(c => <option key={c} value={c}>{c}</option>)}
          </select>
          <select
            value={filters.design}
            onChange={(e) => setFilters(f => ({ ...f, design: e.target.value }))}
          >
            <option value="">All Designs</option>
            {uniqueDesigns.map(d => <option key={d} value={d}>{d}</option>)}
          </select>
          <label className="filter-checkbox">
            <input
              type="checkbox"
              checked={filters.lowStock}
              onChange={(e) => setFilters(f => ({ ...f, lowStock: e.target.checked }))}
            />
            Low Stock Only
          </label>
          {activeFilterCount > 0 && (
            <button className="btn-clear-filters" onClick={clearFilters}>Clear All</button>
          )}
        </div>
      )}

      {filteredProducts.length === 0 ? (
        <div className="sw-empty">
          <p>{activeFilterCount > 0 ? 'No products match your filters.' : 'No inventory yet.'}</p>
          <p className="hint">
            {activeFilterCount > 0
              ? <button className="link-btn" onClick={clearFilters}>Clear filters</button>
              : 'Create products in the Products section to start tracking inventory.'}
          </p>
        </div>
      ) : (
        <div className="inventory-list">
          {filteredProducts.map(product => {
            const isExpanded = expandedProduct === product.product_id;
            const enabledSizes = sizeColumns.filter(size => product.sizes[size.code]?.is_enabled);
            const isLowStock = product.total <= lowStockThreshold;
            return (
              <div key={product.product_id} className={`inventory-card ${isExpanded ? 'expanded' : ''} ${isLowStock ? 'low-stock' : ''}`}>
                <div className="inventory-card-header" onClick={() => toggleExpanded(product.product_id)}>
                  <button className="expand-btn" type="button">
                    {isExpanded ? Icons.chevronDown : Icons.chevronRight}
                  </button>
                  <div className="inventory-product-info">
                    <span className="inventory-sku">{product.sku_prefix}</span>
                    <span className="inventory-meta">
                      {product.vendor_name} {product.blank_name} ·
                      <span className="color-dot" style={{ background: product.hex_color || '#ccc' }} />
                      {product.color_name} · {product.design_name}
                    </span>
                  </div>
                  <div className={`inventory-total-badge ${isLowStock ? 'warning' : ''}`}>
                    {isLowStock && <span className="low-stock-icon">{Icons.lowStock}</span>}
                    <span className="total-num">{product.total}</span>
                    <span className="total-lbl">units</span>
                  </div>
                </div>

                {isExpanded && (
                  <div className="inventory-expanded-content">
                    <div className="size-grid-compact">
                      <div className="size-row size-labels">
                        {enabledSizes.map(size => (
                          <span key={size.code} className="size-col-header">{size.code}</span>
                        ))}
                      </div>
                      <div className="size-row size-values">
                        {enabledSizes.map(size => {
                          const sizeInfo = product.sizes[size.code];
                          const currentQty = isEditing && editData[sizeInfo.inventory_id]
                            ? editData[sizeInfo.inventory_id].quantity
                            : sizeInfo.quantity;
                          return (
                            <div key={size.code} className="size-col-value">
                              {isEditing ? (
                                <input
                                  type="number"
                                  min="0"
                                  value={currentQty}
                                  onChange={(e) => updateQuantity(sizeInfo.inventory_id, e.target.value)}
                                  className="size-input-compact"
                                />
                              ) : (
                                <div className="quick-adjust-group">
                                  <button
                                    className="quick-btn minus"
                                    onClick={(e) => { e.stopPropagation(); quickAdjust(product.product_id, sizeInfo.inventory_id, sizeInfo.quantity, -1); }}
                                    disabled={sizeInfo.quantity === 0}
                                  >
                                    {Icons.minus}
                                  </button>
                                  <span className={sizeInfo.quantity === 0 ? 'qty zero' : 'qty'}>
                                    {sizeInfo.quantity}
                                  </span>
                                  <button
                                    className="quick-btn plus"
                                    onClick={(e) => { e.stopPropagation(); quickAdjust(product.product_id, sizeInfo.inventory_id, sizeInfo.quantity, 1); }}
                                  >
                                    {Icons.plus}
                                  </button>
                                </div>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                    <ProductDetailPanel product={product} sizeColumns={sizeColumns} onRefresh={onRefresh} />
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

// ============ PRODUCT DETAIL PANEL (for inventory grid expansion) ============
function ProductDetailPanel({ product, sizeColumns, onRefresh }) {
  const [sizeData, setSizeData] = useState({});
  const [saving, setSaving] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);
  const toast = useToast();

  useEffect(() => {
    const data = {};
    sizeColumns.forEach(size => {
      const info = product.sizes[size.code];
      if (info) {
        data[info.inventory_id] = {
          cost: info.cost,
          price: info.price,
          is_enabled: info.is_enabled
        };
      }
    });
    setSizeData(data);
  }, [product, sizeColumns]);

  const updateField = (inventoryId, field, value) => {
    setSizeData(prev => ({
      ...prev,
      [inventoryId]: { ...prev[inventoryId], [field]: value }
    }));
    setHasChanges(true);
  };

  const saveChanges = async () => {
    setSaving(true);
    try {
      const adjustments = [];
      sizeColumns.forEach(size => {
        const info = product.sizes[size.code];
        if (info) {
          const data = sizeData[info.inventory_id];
          if (data && (
            data.cost !== info.cost ||
            data.price !== info.price ||
            data.is_enabled !== info.is_enabled
          )) {
            adjustments.push({
              inventoryId: info.inventory_id,
              cost: parseFloat(data.cost) || 0,
              price: parseFloat(data.price) || 0,
              is_enabled: data.is_enabled
            });
          }
        }
      });

      if (adjustments.length > 0) {
        await api.put(`/spirit-wear/products/${product.product_id}/inventory`, {
          adjustments,
          reason: 'settings_update'
        });
        onRefresh();
        toast.addToast('Settings saved', 'success');
      }
      setHasChanges(false);
    } catch (err) {
      toast.addToast(err.response?.data?.error || 'Failed to save', 'error');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="product-detail-panel">
      <div className="detail-header">
        <span className="detail-title">Size Settings: Cost, Price & Availability</span>
        {hasChanges && (
          <button className="btn-save-sm" onClick={saveChanges} disabled={saving}>
            {saving ? 'Saving...' : 'Save Settings'}
          </button>
        )}
      </div>
      <div className="size-settings-grid">
        {sizeColumns.map(size => {
          const info = product.sizes[size.code];
          if (!info) return null;
          const data = sizeData[info.inventory_id] || {};
          const isEnabled = data.is_enabled !== undefined ? data.is_enabled : info.is_enabled;
          return (
            <div key={size.code} className={`size-setting-card ${!isEnabled ? 'disabled' : ''}`}>
              <div className="size-setting-header">
                <span className="size-code">{size.code}</span>
                <label className="enable-toggle">
                  <input
                    type="checkbox"
                    checked={isEnabled}
                    onChange={(e) => updateField(info.inventory_id, 'is_enabled', e.target.checked)}
                  />
                </label>
              </div>
              <div className="size-setting-fields">
                <div className="mini-field">
                  <label>Cost</label>
                  <div className="mini-input-wrap">
                    <span>$</span>
                    <input
                      type="number"
                      min="0"
                      step="0.01"
                      value={data.cost !== undefined ? data.cost : info.cost}
                      onChange={(e) => updateField(info.inventory_id, 'cost', e.target.value)}
                      disabled={!isEnabled}
                    />
                  </div>
                </div>
                <div className="mini-field">
                  <label>Price</label>
                  <div className="mini-input-wrap">
                    <span>$</span>
                    <input
                      type="number"
                      min="0"
                      step="0.01"
                      value={data.price !== undefined ? data.price : info.price}
                      onChange={(e) => updateField(info.inventory_id, 'price', e.target.value)}
                      disabled={!isEnabled}
                    />
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

// ============ PRODUCTS SECTION ============
function ProductsSection({ products, blanks, colors, designs, onRefresh }) {
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({ blank_id: '', color_id: '', design_id: '', name: '' });
  const [saving, setSaving] = useState(false);
  const [editingProduct, setEditingProduct] = useState(null);
  const [editData, setEditData] = useState({ blank_id: '', color_id: '', design_id: '', name: '', is_active: true });
  const toast = useToast();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.blank_id || !formData.color_id || !formData.design_id) {
      toast.addToast('Please select blank, color, and design', 'error');
      return;
    }
    setSaving(true);
    try {
      await api.post('/spirit-wear/products', formData);
      setFormData({ blank_id: '', color_id: '', design_id: '', name: '' });
      setShowForm(false);
      onRefresh();
      toast.addToast('Product created successfully', 'success');
    } catch (err) {
      toast.addToast(err.response?.data?.error || 'Failed to create product', 'error');
    } finally {
      setSaving(false);
    }
  };

  const startEdit = (product) => {
    setEditingProduct(product);
    setEditData({
      blank_id: product.blank_id,
      color_id: product.color_id,
      design_id: product.design_id,
      name: product.name || '',
      is_active: product.is_active !== false
    });
    setShowForm(false);
  };

  const cancelEdit = () => {
    setEditingProduct(null);
    setEditData({ blank_id: '', color_id: '', design_id: '', name: '', is_active: true });
  };

  const saveEdit = async () => {
    if (!editingProduct) return;
    setSaving(true);
    try {
      await api.put(`/spirit-wear/products/${editingProduct.id}`, editData);
      cancelEdit();
      onRefresh();
      toast.addToast('Product updated', 'success');
    } catch (err) {
      toast.addToast(err.response?.data?.error || 'Failed to update product', 'error');
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async () => {
    if (!editingProduct) return;
    if (!window.confirm('Delete this product and all its inventory? This cannot be undone.')) return;
    try {
      await api.delete(`/spirit-wear/products/${editingProduct.id}`);
      cancelEdit();
      onRefresh();
      toast.addToast('Product deleted', 'success');
    } catch (err) {
      toast.addToast(err.response?.data?.error || 'Failed to delete product', 'error');
    }
  };

  const selectedBlank = blanks.find(b => b.id === parseInt(formData.blank_id));
  const selectedColor = colors.find(c => c.id === parseInt(formData.color_id));
  const selectedDesign = designs.find(d => d.id === parseInt(formData.design_id));

  const previewSku = selectedBlank && selectedColor && selectedDesign
    ? `${selectedBlank.vendor_code}${selectedBlank.style_code_short}${selectedColor.code}-${selectedDesign.code}-[SIZE]`
    : null;

  return (
    <div className="sw-section">
      <header className="sw-section-header">
        <h1>Products</h1>
        <button className="btn-primary" onClick={() => { setShowForm(!showForm); cancelEdit(); }}>
          {showForm ? 'Cancel' : '+ New Product'}
        </button>
      </header>

      {showForm && (
        <form className="sw-form product-form" onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-field">
              <label>Blank Shirt</label>
              <select
                value={formData.blank_id}
                onChange={(e) => setFormData(prev => ({ ...prev, blank_id: e.target.value }))}
                required
              >
                <option value="">Select blank...</option>
                {blanks.map(b => (
                  <option key={b.id} value={b.id}>
                    {b.vendor_code} {b.style_code} - {b.name || 'Untitled'}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-field">
              <label>Color</label>
              <select
                value={formData.color_id}
                onChange={(e) => setFormData(prev => ({ ...prev, color_id: e.target.value }))}
                required
              >
                <option value="">Select color...</option>
                {colors.map(c => (
                  <option key={c.id} value={c.id}>{c.name} ({c.code})</option>
                ))}
              </select>
            </div>

            <div className="form-field">
              <label>Design</label>
              <select
                value={formData.design_id}
                onChange={(e) => setFormData(prev => ({ ...prev, design_id: e.target.value }))}
                required
              >
                <option value="">Select design...</option>
                {designs.map(d => (
                  <option key={d.id} value={d.id}>{d.name} ({d.code})</option>
                ))}
              </select>
            </div>
          </div>

          {previewSku && (
            <div className="sku-preview">
              <span className="preview-label">SKU Preview:</span>
              <code>{previewSku}</code>
            </div>
          )}

          <div className="form-actions">
            <button type="submit" className="btn-primary" disabled={saving}>
              {saving ? 'Creating...' : 'Create Product'}
            </button>
          </div>

          {(blanks.length === 0 || colors.length === 0 || designs.length === 0) && (
            <p className="form-hint">
              Missing options? Go to <strong>Manage Products</strong> to add vendors, colors, blanks, and designs first.
            </p>
          )}
        </form>
      )}

      {editingProduct && (
        <div className="product-edit-panel">
          <div className="edit-panel-header">
            <h3>Edit Product</h3>
            <code>{editingProduct.sku_prefix}</code>
          </div>
          <div className="edit-panel-body">
            <div className="edit-form-grid">
              <div className="form-field">
                <label>Blank Shirt</label>
                <select
                  value={editData.blank_id}
                  onChange={(e) => setEditData(prev => ({ ...prev, blank_id: parseInt(e.target.value) }))}
                >
                  {blanks.map(b => (
                    <option key={b.id} value={b.id}>
                      {b.vendor_code} {b.style_code} - {b.name || 'Untitled'}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-field">
                <label>Color</label>
                <select
                  value={editData.color_id}
                  onChange={(e) => setEditData(prev => ({ ...prev, color_id: parseInt(e.target.value) }))}
                >
                  {colors.map(c => (
                    <option key={c.id} value={c.id}>{c.name} ({c.code})</option>
                  ))}
                </select>
              </div>

              <div className="form-field">
                <label>Design</label>
                <select
                  value={editData.design_id}
                  onChange={(e) => setEditData(prev => ({ ...prev, design_id: parseInt(e.target.value) }))}
                >
                  {designs.map(d => (
                    <option key={d.id} value={d.id}>{d.name} ({d.code})</option>
                  ))}
                </select>
              </div>

              <div className="form-field">
                <label>Product Name (optional)</label>
                <input
                  type="text"
                  value={editData.name}
                  onChange={(e) => setEditData(prev => ({ ...prev, name: e.target.value }))}
                  placeholder="Friendly name for this product"
                />
              </div>
            </div>

            <div className="edit-panel-options">
              <div className="form-field checkbox-field">
                <label>
                  <input
                    type="checkbox"
                    checked={editData.is_active}
                    onChange={(e) => setEditData(prev => ({ ...prev, is_active: e.target.checked }))}
                  />
                  Active
                </label>
                <span className="field-hint">Inactive products won't appear in inventory</span>
              </div>
            </div>
          </div>
          <div className="edit-panel-actions">
            <button className="btn-delete" onClick={handleDelete}>Delete</button>
            <div className="edit-panel-actions-right">
              <button className="btn-cancel" onClick={cancelEdit}>Cancel</button>
              <button className="btn-save" onClick={saveEdit} disabled={saving}>
                {saving ? 'Saving...' : 'Save Changes'}
              </button>
            </div>
          </div>
        </div>
      )}

      {products.length === 0 ? (
        <div className="sw-empty">
          <p>No products yet.</p>
          <p className="hint">Create your first product above, or go to Manage Products to add vendors, blanks, colors, and designs.</p>
        </div>
      ) : (
        <table className="sw-table">
          <thead>
            <tr>
              <th>SKU Prefix</th>
              <th>Vendor</th>
              <th>Blank</th>
              <th>Color</th>
              <th>Design</th>
              <th>Name</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {products.map(p => (
              <tr key={p.id} className={p.is_active === false ? 'inactive-row' : ''}>
                <td><code>{p.sku_prefix}</code></td>
                <td>{p.vendor_name}</td>
                <td>{p.blank_name || p.style_code}</td>
                <td>
                  <span className="color-dot" style={{ background: p.hex_color || '#ccc' }} />
                  {p.color_name}
                </td>
                <td>{p.design_name}</td>
                <td className="name-cell">{p.name || '—'}</td>
                <td>
                  <span className={`status-badge ${p.is_active === false ? 'inactive' : 'active'}`}>
                    {p.is_active === false ? 'Inactive' : 'Active'}
                  </span>
                </td>
                <td>
                  <button className="btn-edit" onClick={() => startEdit(p)}>Edit</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

// ============ SETUP WIZARD ============
function SetupWizard({ vendors, colors, blanks, designs, onRefresh }) {
  return (
    <div className="sw-section setup-wizard">
      <header className="sw-section-header">
        <h1>Manage Products</h1>
        <p className="setup-subtitle">Configure your vendors, colors, blanks, and designs</p>
      </header>

      <div className="wizard-grid">
        <VendorCard vendors={vendors} onRefresh={onRefresh} />
        <ColorCard colors={colors} onRefresh={onRefresh} />
        <BlankCard blanks={blanks} vendors={vendors} onRefresh={onRefresh} />
        <DesignCard designs={designs} onRefresh={onRefresh} />
      </div>
    </div>
  );
}

// ============ VENDOR CARD ============
function VendorCard({ vendors, onRefresh }) {
  const [adding, setAdding] = useState(false);
  const [editing, setEditing] = useState(null);
  const [code, setCode] = useState('');
  const [name, setName] = useState('');
  const [saving, setSaving] = useState(false);
  const toast = useToast();

  const startEdit = (vendor) => {
    setEditing(vendor.id);
    setCode(vendor.code);
    setName(vendor.name);
    setAdding(false);
  };

  const startAdd = () => {
    setAdding(true);
    setEditing(null);
    setCode('');
    setName('');
  };

  const cancel = () => {
    setAdding(false);
    setEditing(null);
    setCode('');
    setName('');
  };

  const save = async () => {
    if (!code.trim() || !name.trim()) return;
    setSaving(true);
    try {
      if (editing) {
        await api.put(`/spirit-wear/vendors/${editing}`, { code, name, is_active: true });
      } else {
        await api.post('/spirit-wear/vendors', { code, name });
      }
      cancel();
      onRefresh();
      toast.addToast('Vendor saved', 'success');
    } catch (err) {
      toast.addToast(err.response?.data?.error || 'Failed to save', 'error');
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (id, e) => {
    e.stopPropagation();
    if (!window.confirm('Delete this vendor?')) return;
    try {
      await api.delete(`/spirit-wear/vendors/${id}`);
      cancel();
      onRefresh();
      toast.addToast('Vendor deleted', 'success');
    } catch (err) {
      toast.addToast(err.response?.data?.error || 'Failed to delete', 'error');
    }
  };

  return (
    <div className="wizard-card">
      <div className="wizard-card-header">
        <div className="wizard-card-title">
          <span className="wizard-icon">{Icons.vendor}</span>
          <h3>Vendors</h3>
          <span className="wizard-count">{vendors.length}</span>
        </div>
        <button className="btn-add-sm" onClick={startAdd}>+ Add</button>
      </div>

      {(adding || editing) && (
        <div className="wizard-form">
          <input
            type="text"
            placeholder="Code (e.g. GIL)"
            value={code}
            onChange={(e) => setCode(e.target.value.toUpperCase())}
            maxLength={10}
          />
          <input
            type="text"
            placeholder="Name (e.g. Gildan)"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <div className="wizard-form-actions">
            <button className="btn-save-sm" onClick={save} disabled={saving}>
              {saving ? '...' : 'Save'}
            </button>
            <button className="btn-cancel-sm" onClick={cancel}>Cancel</button>
            {editing && (
              <button className="btn-delete-sm" onClick={(e) => handleDelete(editing, e)}>Delete</button>
            )}
          </div>
        </div>
      )}

      <div className="wizard-list">
        {vendors.length === 0 ? (
          <p className="wizard-empty">No vendors yet</p>
        ) : (
          vendors.map(v => (
            <div key={v.id} className="wizard-item" onClick={() => startEdit(v)}>
              <code>{v.code}</code>
              <span>{v.name}</span>
              <button className="btn-edit-icon">✎</button>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

// ============ COLOR CARD ============
function ColorCard({ colors, onRefresh }) {
  const [adding, setAdding] = useState(false);
  const [editing, setEditing] = useState(null);
  const [code, setCode] = useState('');
  const [name, setName] = useState('');
  const [hex, setHex] = useState('#000000');
  const [saving, setSaving] = useState(false);
  const toast = useToast();

  const startEdit = (color) => {
    setEditing(color.id);
    setCode(color.code);
    setName(color.name);
    setHex(color.hex_color || '#000000');
    setAdding(false);
  };

  const startAdd = () => {
    setAdding(true);
    setEditing(null);
    setCode('');
    setName('');
    setHex('#000000');
  };

  const cancel = () => {
    setAdding(false);
    setEditing(null);
  };

  const save = async () => {
    if (!code.trim() || !name.trim()) return;
    setSaving(true);
    try {
      if (editing) {
        await api.put(`/spirit-wear/colors/${editing}`, { code, name, hex_color: hex, is_active: true });
      } else {
        await api.post('/spirit-wear/colors', { code, name, hex_color: hex });
      }
      cancel();
      onRefresh();
      toast.addToast('Color saved', 'success');
    } catch (err) {
      toast.addToast(err.response?.data?.error || 'Failed to save', 'error');
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (id, e) => {
    e.stopPropagation();
    if (!window.confirm('Delete this color?')) return;
    try {
      await api.delete(`/spirit-wear/colors/${id}`);
      cancel();
      onRefresh();
      toast.addToast('Color deleted', 'success');
    } catch (err) {
      toast.addToast(err.response?.data?.error || 'Failed to delete', 'error');
    }
  };

  return (
    <div className="wizard-card">
      <div className="wizard-card-header">
        <div className="wizard-card-title">
          <span className="wizard-icon">{Icons.color}</span>
          <h3>Colors</h3>
          <span className="wizard-count">{colors.length}</span>
        </div>
        <button className="btn-add-sm" onClick={startAdd}>+ Add</button>
      </div>

      {(adding || editing) && (
        <div className="wizard-form">
          <div className="wizard-form-row">
            <input
              type="text"
              placeholder="Code (e.g. BLK)"
              value={code}
              onChange={(e) => setCode(e.target.value.toUpperCase())}
              maxLength={10}
            />
            <input
              type="color"
              value={hex}
              onChange={(e) => setHex(e.target.value)}
              className="color-picker"
            />
          </div>
          <input
            type="text"
            placeholder="Name (e.g. Black)"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <div className="wizard-form-actions">
            <button className="btn-save-sm" onClick={save} disabled={saving}>
              {saving ? '...' : 'Save'}
            </button>
            <button className="btn-cancel-sm" onClick={cancel}>Cancel</button>
            {editing && (
              <button className="btn-delete-sm" onClick={(e) => handleDelete(editing, e)}>Delete</button>
            )}
          </div>
        </div>
      )}

      <div className="wizard-list color-list">
        {colors.length === 0 ? (
          <p className="wizard-empty">No colors yet</p>
        ) : (
          colors.map(c => (
            <div key={c.id} className="wizard-item color-item" onClick={() => startEdit(c)}>
              <span className="color-swatch" style={{ background: c.hex_color || '#ccc' }} />
              <span className="color-name">{c.name}</span>
              <code>{c.code}</code>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

// ============ BLANK CARD ============
function BlankCard({ blanks, vendors, onRefresh }) {
  const [adding, setAdding] = useState(false);
  const [editing, setEditing] = useState(null);
  const [vendorId, setVendorId] = useState('');
  const [styleCode, setStyleCode] = useState('');
  const [styleCodeShort, setStyleCodeShort] = useState('');
  const [name, setName] = useState('');
  const [saving, setSaving] = useState(false);
  const toast = useToast();

  const startEdit = (blank) => {
    setEditing(blank.id);
    setVendorId(blank.vendor_id);
    setStyleCode(blank.style_code);
    setStyleCodeShort(blank.style_code_short);
    setName(blank.name || '');
    setAdding(false);
  };

  const startAdd = () => {
    setAdding(true);
    setEditing(null);
    setVendorId('');
    setStyleCode('');
    setStyleCodeShort('');
    setName('');
  };

  const cancel = () => {
    setAdding(false);
    setEditing(null);
  };

  const save = async () => {
    if (!vendorId || !styleCode.trim() || !styleCodeShort.trim()) return;
    setSaving(true);
    try {
      const data = { vendor_id: vendorId, style_code: styleCode, style_code_short: styleCodeShort, name };
      if (editing) {
        await api.put(`/spirit-wear/blanks/${editing}`, { ...data, is_active: true });
      } else {
        await api.post('/spirit-wear/blanks', data);
      }
      cancel();
      onRefresh();
      toast.addToast('Blank saved', 'success');
    } catch (err) {
      toast.addToast(err.response?.data?.error || 'Failed to save', 'error');
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (id, e) => {
    e.stopPropagation();
    if (!window.confirm('Delete this blank?')) return;
    try {
      await api.delete(`/spirit-wear/blanks/${id}`);
      cancel();
      onRefresh();
      toast.addToast('Blank deleted', 'success');
    } catch (err) {
      toast.addToast(err.response?.data?.error || 'Failed to delete', 'error');
    }
  };

  return (
    <div className="wizard-card">
      <div className="wizard-card-header">
        <div className="wizard-card-title">
          <span className="wizard-icon">{Icons.blank}</span>
          <h3>Blanks</h3>
          <span className="wizard-count">{blanks.length}</span>
        </div>
        <button className="btn-add-sm" onClick={startAdd} disabled={vendors.length === 0}>+ Add</button>
      </div>

      {vendors.length === 0 && (
        <p className="wizard-warning">Add a vendor first</p>
      )}

      {(adding || editing) && (
        <div className="wizard-form">
          <select value={vendorId} onChange={(e) => setVendorId(e.target.value)}>
            <option value="">Select vendor...</option>
            {vendors.map(v => (
              <option key={v.id} value={v.id}>{v.code} - {v.name}</option>
            ))}
          </select>
          <div className="wizard-form-row">
            <input
              type="text"
              placeholder="Style (64000)"
              value={styleCode}
              onChange={(e) => setStyleCode(e.target.value)}
            />
            <input
              type="text"
              placeholder="SKU (640)"
              value={styleCodeShort}
              onChange={(e) => setStyleCodeShort(e.target.value.toUpperCase())}
              maxLength={10}
            />
          </div>
          <input
            type="text"
            placeholder="Name (optional)"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <div className="wizard-form-actions">
            <button className="btn-save-sm" onClick={save} disabled={saving}>
              {saving ? '...' : 'Save'}
            </button>
            <button className="btn-cancel-sm" onClick={cancel}>Cancel</button>
            {editing && (
              <button className="btn-delete-sm" onClick={(e) => handleDelete(editing, e)}>Delete</button>
            )}
          </div>
        </div>
      )}

      <div className="wizard-list">
        {blanks.length === 0 ? (
          <p className="wizard-empty">No blanks yet</p>
        ) : (
          blanks.map(b => (
            <div key={b.id} className="wizard-item" onClick={() => startEdit(b)}>
              <code>{b.vendor_code}{b.style_code_short}</code>
              <span>{b.style_code} {b.name && `- ${b.name}`}</span>
              <button className="btn-edit-icon">✎</button>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

// ============ DESIGN CARD ============
function DesignCard({ designs, onRefresh }) {
  const [adding, setAdding] = useState(false);
  const [editing, setEditing] = useState(null);
  const [code, setCode] = useState('');
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [saving, setSaving] = useState(false);
  const fileInputRef = useRef(null);
  const toast = useToast();

  const startEdit = (design) => {
    setEditing(design.id);
    setCode(design.code);
    setName(design.name);
    setDescription(design.description || '');
    setImagePreview(design.image_path);
    setImageFile(null);
    setAdding(false);
  };

  const startAdd = () => {
    setAdding(true);
    setEditing(null);
    setCode('');
    setName('');
    setDescription('');
    setImageFile(null);
    setImagePreview(null);
  };

  const cancel = () => {
    setAdding(false);
    setEditing(null);
    setImageFile(null);
    setImagePreview(null);
  };

  const handleImageSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
      const reader = new FileReader();
      reader.onload = (e) => setImagePreview(e.target.result);
      reader.readAsDataURL(file);
    }
  };

  const save = async () => {
    if (!code.trim() || !name.trim()) return;
    setSaving(true);
    try {
      const formData = new FormData();
      formData.append('code', code.trim());
      formData.append('name', name.trim());
      formData.append('description', description.trim());
      if (imageFile) {
        formData.append('image', imageFile);
      }

      if (editing) {
        formData.append('is_active', 'true');
        await api.put(`/spirit-wear/designs/${editing}`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
      } else {
        await api.post('/spirit-wear/designs', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
      }
      cancel();
      onRefresh();
      toast.addToast('Design saved', 'success');
    } catch (err) {
      toast.addToast(err.response?.data?.error || 'Failed to save', 'error');
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (id, e) => {
    e.stopPropagation();
    if (!window.confirm('Delete this design?')) return;
    try {
      await api.delete(`/spirit-wear/designs/${id}`);
      cancel();
      onRefresh();
      toast.addToast('Design deleted', 'success');
    } catch (err) {
      toast.addToast(err.response?.data?.error || 'Failed to delete', 'error');
    }
  };

  return (
    <div className="wizard-card wizard-card-wide">
      <div className="wizard-card-header">
        <div className="wizard-card-title">
          <span className="wizard-icon">{Icons.design}</span>
          <h3>Designs</h3>
          <span className="wizard-count">{designs.length}</span>
        </div>
        <button className="btn-add-sm" onClick={startAdd}>+ Add</button>
      </div>

      {(adding || editing) && (
        <div className="wizard-form design-form">
          <div className="design-form-layout">
            <div className="design-image-upload" onClick={() => fileInputRef.current?.click()}>
              {imagePreview ? (
                <img src={imagePreview} alt="Preview" />
              ) : (
                <div className="upload-placeholder">
                  <span className="upload-icon">📷</span>
                  <span>Click to upload image</span>
                </div>
              )}
              <input
                ref={fileInputRef}
                type="file"
                accept="image/*"
                onChange={handleImageSelect}
                style={{ display: 'none' }}
              />
            </div>
            <div className="design-form-fields">
              <input
                type="text"
                placeholder="Code (e.g. EGL01)"
                value={code}
                onChange={(e) => setCode(e.target.value.toUpperCase())}
                maxLength={20}
              />
              <input
                type="text"
                placeholder="Design Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              <textarea
                placeholder="Description (optional)"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                rows={2}
              />
              <div className="wizard-form-actions">
                <button className="btn-save-sm" onClick={save} disabled={saving}>
                  {saving ? '...' : 'Save'}
                </button>
                <button className="btn-cancel-sm" onClick={cancel}>Cancel</button>
                {editing && (
                  <button className="btn-delete-sm" onClick={(e) => handleDelete(editing, e)}>Delete</button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="design-grid">
        {designs.length === 0 ? (
          <p className="wizard-empty">No designs yet</p>
        ) : (
          designs.map(d => (
            <div key={d.id} className="design-card" onClick={() => startEdit(d)}>
              <div className="design-card-image">
                {d.image_path ? (
                  <img src={d.image_path} alt={d.name} />
                ) : (
                  <div className="no-image">No image</div>
                )}
                <button className="design-edit-btn">✎</button>
              </div>
              <div className="design-card-info">
                <span className="design-card-name">{d.name}</span>
                <code>{d.code}</code>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

function SpiritWearApp() {
  return (
    <ToastProvider>
      <SpiritWearDashboard />
    </ToastProvider>
  );
}

export default SpiritWearApp;
